import { HomeLoadFlags } from './home.types';

/**
 * Load-flag join logic for the home section: the view can only be set up once
 * the DOM fragment, the Pixi particles spritesheet and the section JSON have
 * all arrived. Note: this section does no fetching of its own — HTML/JSON are
 * pushed in by the app level via HomeController.setHTML (AJAX) / setJSON
 * (bundled config — AppController._setSectionConfigs).
 *
 * NOTE: the `moth` flag existed on the original controller but was never set
 * or read by the join — kept for parity, flagged as dead.
 */
export class HomeLoading {
	private _loadFlags: HomeLoadFlags = { pixi: false, moth: false, dom: false, json: false };
	private _readyToSetup: boolean = false; //Is ready to view. So can be setup for viewing oif required

	public get readyToSetup(): boolean {
		return this._readyToSetup;
	}

	public setFlag(flag: keyof HomeLoadFlags, value: boolean = true): void {
		this._loadFlags[flag] = value;
	}

	/** Test that the view is ready to setup */
	public testReadyToSetup(): void {
		this._readyToSetup = this._loadFlags.dom && this._loadFlags.pixi && this._loadFlags.json;
	}
}
